import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/button/button';
import { Container } from '../components/container/container';
import { Input } from '../components/input/input';
import { LoginWrap } from '../components/login/login';
import { trackLoginClicked } from '../utils/analytics';
import useActiveYear from '../hooks/useActiveYear';

export function Login() {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const ACTIVE_YEAR = useActiveYear();

  useEffect(() => {
    trackLoginClicked();
    if (!isAuthenticated) {
      localStorage.setItem(
        'returnTo',
        decodeURIComponent(searchParams.get('returnTo') || '')
      );
      loginWithRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthenticated) {
    return <Navigate to={`/${ACTIVE_YEAR}/lots`} />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Container>
      <LoginWrap
        title="Login to your account"
        action={
          <Button fullWidth onClick={() => loginWithRedirect()}>
            Log In
          </Button>
        }
        forgotPass={<Link to="/">Forgot your password?</Link>}
        signup={
          <>
            Don’t have an account? <Link to="/">Sign up</Link>
          </>
        }
      >
        <Input placeholder="Email address" />
        <Input placeholder="Password" />
      </LoginWrap>
    </Container>
  );
}
